import BPCApiInterceptor from '@core/interceptors/bpc-api-interceptors';
import BCApiDebugInterceptor from '@core/interceptors/bc-api-debug-interceptor';

import Vue, { VueConstructor } from 'vue';
import AuthModule from '@auth/auth.module';
import BPCStoreService from './services/bpc-storage.service';
import BPCMessageService from './services/bpc-messages.service';
import TranslationsService from './services/translations.service';
import { extend, localize } from 'vee-validate';
import en from 'vee-validate/dist/locale/en.json';
import fr from 'vee-validate/dist/locale/fr.json';
import nl from 'vee-validate/dist/locale/nl.json';
import es from 'vee-validate/dist/locale/es.json';
import * as rules from 'vee-validate/dist/rules';
import BPCModelFactoryService from './services/bpc-model-factory.service';
import BPCConfigService from '@core/services/bpc-config.service';
import BPCEchoService from '@core/services/bpc-echo.service';
import ModulesService from './services/modules.service';
import EventsService from './services/events.service';
import ClientRouterService from './services/client-router.service';
import { bpcApi } from './services/bpc-api.service';
import BPCApiRouteHelper from './helpers/bpc-api-route.helper';
import PortalVue from 'portal-vue';
import BPCCommonHelper from './helpers/common-helper';

declare module 'vue/types/vue' {
  interface Vue {
    $bpcApi: typeof bpcApi;
    $bpcMessage: BPCMessageService;
    $authModule: AuthModule;
    $bpcStorage: BPCStoreService;
    $bpcModelFactory: BPCModelFactoryService;
    translationService: TranslationsService;
    $bpcConfig: BPCConfigService;
    $bpcEcho: BPCEchoService;
    $modulesService: ModulesService;
    $eventsService: EventsService;
    $clientRouter: ClientRouterService;
    $bpcApiRouteHelper: BPCApiRouteHelper;
    $bpcHelper: BPCCommonHelper;
  }
}

export default class CoreModule {
  static install(Vue: VueConstructor<Vue>): void {
    console.log('initiating Core module');
    CoreModule.manageTranslations(Vue);
    CoreModule.addAuthSubmodule(Vue);
    CoreModule.registerServices(Vue);
    CoreModule.registerCoreComponents(Vue);
  }

  static manageTranslations(Vue: VueConstructor<Vue>) {
    const defaultLang = localStorage.getItem('lang') ? localStorage.getItem('lang') : '';
    switch (defaultLang) {
      case 'nl':
        localize(defaultLang, nl);
        break;
      case 'fr':
        localize(defaultLang, fr);
        break;
      case 'be':
        localize(defaultLang, fr);
        break;
      case 'es':
        localize(defaultLang, es);
        break;
      default:
        localize(defaultLang, en);
        break;
    }
    Object.keys(rules).forEach(rule => {
      extend(rule, rules[rule]);
    });
    Vue.prototype.translationService = new TranslationsService();
  }

  static addAuthSubmodule(Vue: VueConstructor<Vue>) {
    Vue.use(AuthModule);
  }

  static registerServices(Vue: VueConstructor<Vue>) {
    Vue.prototype.$bpcApi = bpcApi;
    Vue.prototype.$bpcApiRouteHelper = new BPCApiRouteHelper();
    Vue.prototype.$bpcMessage = new BPCMessageService();
    Vue.prototype.$bpcApiInterceptor = new BPCApiInterceptor();
    Vue.prototype.$bpcApiDebugInterceptor = new BCApiDebugInterceptor();
    Vue.prototype.$bpcStorage = new BPCStoreService();
    Vue.prototype.$bpcModelFactory = new BPCModelFactoryService();
    Vue.prototype.$bpcConfig = new BPCConfigService();
    Vue.prototype.$bpcEcho = new BPCEchoService();
    Vue.prototype.$modulesService = new ModulesService();
    Vue.prototype.$eventsService = new EventsService();
    Vue.prototype.$clientRouter = new ClientRouterService();
    Vue.prototype.$bpcHelper = new BPCCommonHelper();
  }
  static registerCoreComponents(Vue: VueConstructor<Vue>) {
    Vue.use(PortalVue);
  }
}
